/* Tag filter pills: purely client-side show/hide over already-rendered cards,
   so switching tabs is instant and needs no request. */
(function () {
  var ACTIVE = 'bl-pill--brand';
  var IDLE = 'bl-pill--muted';

  function setup(root) {
    if (root.dataset.blTabsReady === '1') return;
    root.dataset.blTabsReady = '1';

    var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-bl-tab]'));
    var grid = root.querySelector('[data-bl-tabs-grid]');
    var empty = root.querySelector('[data-bl-tabs-empty]');
    if (!buttons.length || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.bl-card'));

    function apply(tag) {
      var shown = 0;
      cards.forEach(function (card) {
        var tags = (card.dataset.blTags || '').split('|');
        var match = !tag || tags.indexOf(tag) !== -1;
        card.hidden = !match;
        if (match) shown++;
      });
      if (empty) empty.hidden = shown !== 0;

      buttons.forEach(function (b) {
        var on = b.dataset.blTab === tag;
        b.classList.toggle(ACTIVE, on);
        b.classList.toggle(IDLE, !on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      // the track is a slider: rewind and let the carousel recompute arrow state
      grid.scrollLeft = 0;
      grid.dispatchEvent(new Event('scroll'));
    }

    buttons.forEach(function (b) {
      b.addEventListener('click', function () { apply(b.dataset.blTab); });
    });

    apply('');
  }

  function init() { document.querySelectorAll('[data-bl-tabs]').forEach(setup); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
